import { Tooltip } from 'antd';
import React, { forwardRef } from 'react';
import Styled from './Styled';
const IconButton = forwardRef(({ title, ...props }, ref) => (React.createElement(Tooltip, { title: title },
    React.createElement("div", null,
        React.createElement(Styled.Wrapper, Object.assign({ ref: ref }, props))))));
export default IconButton;
